import React from 'react';
import PropTypes from 'prop-types';
import Header from 'components/Header';
import styles from './index.module.scss';
import iconClose from 'images/icon_close.svg';
import Button from 'components/Button';
import Portal from 'portal/Portal';
import { useTranslation } from 'react-i18next';
import { Paper } from '@material-ui/core';
import cn from 'classnames';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  messageTextColor: {
    color: theme.palette.text.primary,
  },
  formContainerColor: {
    background: theme.palette.background.default,
  },
}));

const PopUp = ({
  title,
  close,
  statusMessage,
  actionMessage,
  submit,
  submitBtnText,
  cancel,
  cancelBtnText,
}) => {
  const classes = useStyles();

  const { t } = useTranslation();
  return (
    <Portal id={'portal'}>
      <Paper className={cn(styles.formContainer, classes.formContainerColor)}>
        <Header
          title={t(title)}
          icon={iconClose}
          onClick={close}
          iconTitle={t(cancelBtnText)}
        />
        <section className={styles.section}>
          <div className={cn(styles.message, classes.messageTextColor)}>
            <p>{t(statusMessage)}</p>
            <p>{t(actionMessage)}</p>
          </div>

          <div className={styles.btnRow}>
            {cancel && (
              <Button
                text={t(cancelBtnText)}
                size="l"
                color="secondary"
                onClick={cancel}
                theme="light"
                outline={true}
              />
            )}
            {submit && (
              <Button
                text={t(submitBtnText)}
                size="l"
                color={'primary'}
                onClick={submit}
                theme="light"
              />
            )}
          </div>
        </section>
      </Paper>
    </Portal>
  );
};

PopUp.propTypes = {
  title: PropTypes.string,
  close: PropTypes.func,
  statusMessage: PropTypes.string,
  actionMessage: PropTypes.string,
  submit: PropTypes.func,
  cancel: PropTypes.func,
  submitBtnText: PropTypes.string,
  cancelBtnText: PropTypes.string,
};

export default PopUp;
